<template>
  <div class="image-preview" :class="{ 'image-preview--loading': uploading }">
    <span class="h2 mb-4">Your submission</span>
    <div class="image-preview__container">
      <div class="image-preview__file-container">
        <img
          class="image-preview__file"
          :src="img"
          alt="My submission preview"
        />
      </div>
      <div class="image-preview__comment-container">
        <text-field
          class="text-field"
          v-model="comment"
          type="multi"
          label="Comment (optional)"
          name="comment"
        />
      </div>
    </div>
    <app-loader v-if="uploading" />
    <div class="image-preview__menu">
      <div class="image-preview__actions">
        <app-button variant="text" @click.native="cancelUpload"
          >Cancel</app-button
        >
        <app-button
          class="submit-button"
          variant="cta"
          :disabled="disabled"
          align="stretch"
          @click.native="submitHandler"
          >Submit study</app-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import AppLoader from '@/components/global/Loader';
import TextField from '@/components/form/TextField';
import { mapState, mapActions } from 'vuex';

export default {
  props: ['img', 'uploading'],
  name: 'submission-confirm',
  components: { AppLoader, TextField },
  data: function() {
    return {
      disabled: false,
      comment: '',
    };
  },
  methods: {
    ...mapActions('uploadSubmission', ['setComment']),
    cancelUpload() {
      this.$emit('cancel');
    },
    submitHandler() {
      this.disabled = true;
      this.$gtag.event('add_submission', {
        event_category: 'participation',
        event_label: 'Upload a submission',
      });
      this.setComment(this.comment);
      this.$emit('handleSubmit');
    },
  },
  computed: {
    ...mapState('my-submissions', {
      error: state => state.error,
    }),
  },
};
</script>

<style lang="scss" scoped>
.image-preview {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  border-radius: 8px;

  &--loading {
    .image-preview__file-container {
      opacity: 0.5;
    }
  }

  .title-large {
    color: color('denotive', 'success');
  }

  &__container {
    display: flex;
  }

  &__comment-container {
    display: flex;
    flex: 3;
    margin-left: 2rem;

    .text-field {
      flex: 1;
      max-height: 240px;
    }
  }

  &__file-container {
    display: flex;
    justify-content: center;
    flex: 2;
  }

  &__file {
    align-self: center;
    border-radius: 4px;
    max-width: 100%;
    max-height: 300px;
  }

  &__menu {
    display: flex;
    flex-direction: column;
    text-align: center;
  }

  &__actions {
    margin-top: auto;
    display: flex;
    flex-direction: column;

    @media screen and (min-width: 1024px) {
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
    }

    span {
      display: flex;
      text-align: center;
      justify-content: center;
      cursor: pointer;
      margin-right: 1rem;
      color: color('text', 'light');

      &:hover {
        color: color('primary');
      }
    }
  }
}
</style>
